(() => {
  if (window.ibeadDepartmentMenuLoaded) return;
  window.ibeadDepartmentMenuLoaded = true;

  function initialize(scope = document) {
    scope.querySelectorAll('#vertical-nav-css').forEach(wrapper => {
      if (wrapper.dataset.ibeadInitialized) return;
      wrapper.dataset.ibeadInitialized = 'true';
      const trigger = wrapper.querySelector('[data-ibead-toggle], [data-vertical-toggle]');
      const nav = document.getElementById(trigger?.getAttribute('aria-controls'));
      const container = wrapper.closest('#HeaderNavigation');
      if (!trigger || !nav || !container) return;
      const desktop = window.matchMedia('(min-width: 1025px)');
      const root = nav.querySelector('[data-ibead-menu]');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const buttons = root ? [...root.querySelectorAll('[data-department]')] : [];
      const panels = root ? [...root.querySelectorAll('[data-department-panel]')] : [];
      let selected = buttons[0]?.dataset.department;
      let frame;

      function measure() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!desktop.matches) return;
          const bounds = container.getBoundingClientRect();
          const start = wrapper.getBoundingClientRect();
          const width = Math.max(0, bounds.right - start.left);
          const available = Math.max(0, window.innerHeight - start.bottom - 16);
          nav.style.setProperty('--ibead-menu-width', `${width}px`);
          nav.style.setProperty('--ibead-flyout-width', `${Math.max(0, width - nav.getBoundingClientRect().width)}px`);
          nav.style.setProperty('--ibead-menu-space', `${available}px`);
        });
      }

      function selectDepartment(id, focusPanel = false) {
        selected = id;
        buttons.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.department === id)));
        panels.forEach(panel => { panel.hidden = panel.dataset.departmentPanel !== id; });
        if (!desktop.matches) root.setAttribute('data-mobile-depth', '');
        if (focusPanel) panels.find(panel => !panel.hidden)?.querySelector(desktop.matches ? 'a' : 'button')?.focus();
      }

      function close(restoreFocus = false) {
        wrapper.removeAttribute('data-ibead-open');
        document.body.classList.remove('ibead-departments-open');
        document.getElementById('menu-overlay')?.classList.remove('is-visible');
        trigger.setAttribute('aria-expanded', 'false');
        nav.inert = desktop.matches;
        if (restoreFocus) trigger.focus();
      }

      function open() {
        measure();
        nav.inert = false;
        wrapper.setAttribute('data-ibead-open', '');
        document.body.classList.add('ibead-departments-open');
        trigger.setAttribute('aria-expanded', 'true');
        selectDepartment(selected);
      }

      function mobileHome() {
        root.removeAttribute('data-mobile-depth');
        buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
        panels.forEach(panel => { panel.hidden = true; });
      }

      function mountMobile() {
        if (desktop.matches) return;
        const target = document.querySelector('#navigation-mobile .site-nav-mobile.nav');
        const heading = target?.querySelector('.menu-heading-mobile');
        if (!target || !heading) return;
        if (nav.parentElement !== target) target.append(nav);
        nav.classList.add('header__inline-menu');
        const titleText = trigger.querySelector('.title')?.textContent.trim();
        let title = [...heading.querySelectorAll('.title')].find(item => item.textContent.trim() === titleText);
        if (!title) {
          title = document.createElement('span');
          title.className = 'title';
          title.textContent = titleText;
          heading.append(title);
        }
        const activate = () => {
          heading.querySelectorAll('.title').forEach(item => item.classList.toggle('is-active', item === title));
          target.querySelectorAll(':scope > .header__inline-menu').forEach(item => item.classList.toggle('is-active', item === nav));
        };
        if (!title.dataset.ibeadTab) {
          title.dataset.ibeadTab = 'true';
          title.addEventListener('click', activate, options);
        }
        activate();
        mobileHome();
        nav.inert = false;
      }

      function changeLayout() {
        if (!root) { measure(); return; }
        close();
        root.removeAttribute('data-mobile-depth');
        if (desktop.matches) {
          wrapper.append(nav);
          nav.classList.remove('header__inline-menu', 'is-active');
          selectDepartment(selected);
          measure();
        } else {
          nav.inert = false;
          mobileHome();
          if (document.body.classList.contains('menu_open')) mountMobile();
        }
      }

      const resize = new ResizeObserver(measure);
      resize.observe(container);
      resize.observe(wrapper);
      window.addEventListener('resize', measure, options);
      desktop.addEventListener('change', changeLayout, options);
      if (root) {
        trigger.addEventListener('click', event => {
          if (!desktop.matches) return;
          event.preventDefault();
          event.stopPropagation();
          wrapper.hasAttribute('data-ibead-open') ? close() : open();
        }, options);
        buttons.forEach((button, index) => {
          button.addEventListener('pointerenter', event => {
            if (desktop.matches && event.pointerType !== 'touch' && wrapper.hasAttribute('data-ibead-open')) {
              selectDepartment(button.dataset.department);
            }
          }, options);
          button.addEventListener('click', () => selectDepartment(button.dataset.department, !desktop.matches), options);
          button.addEventListener('focus', () => {
            if (desktop.matches) selectDepartment(button.dataset.department);
          }, options);
          button.addEventListener('keydown', event => {
            if (!desktop.matches) return;
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault();
              buttons[(index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length].focus();
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              selectDepartment(button.dataset.department, true);
            }
          }, options);
        });
        root.querySelectorAll('[data-department-back]').forEach(button => button.addEventListener('click', () => {
          mobileHome();
          buttons.find(item => item.dataset.department === selected)?.focus();
        }, options));
        document.addEventListener('click', event => {
          if (desktop.matches && wrapper.hasAttribute('data-ibead-open') && !wrapper.contains(event.target)) close();
          if (!desktop.matches && event.target.closest('.mobileMenu-toggle')) requestAnimationFrame(mountMobile);
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          if (desktop.matches && wrapper.hasAttribute('data-ibead-open')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            close(true);
          } else if (!desktop.matches && root.contains(event.target) && root.hasAttribute('data-mobile-depth')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            mobileHome();
            buttons.find(button => button.dataset.department === selected)?.focus();
          }
        }, { ...options, capture: true });
        wrapper.addEventListener('focusout', event => {
          if (desktop.matches && event.relatedTarget && !wrapper.contains(event.relatedTarget)) close();
        }, options);
        window.addEventListener('scroll', measure, { ...options, passive: true });
      }
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(wrapper)) return;
        if (root) close();
        controller.abort();
        resize.disconnect();
        cancelAnimationFrame(frame);
      }, options);
      changeLayout();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
